
export default [
  {
    path: '/',
    meta: {
    },
    component: () => import('@/views/index')
  },
]

